import { observable, reaction, isObservableArray, makeObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'

import FixedWeight from './FixedWeight'
import QuestionWeight from './QuestionWeight'
import NumericOption from './NumericOption'

class Variable {
    id

    @observable name

    @observable variableType

    @observable questionId

    @observable optionId

    @observable rowId

    @observable weight

    @observable numericOptions

    constructor({
        name,
        variableType,
        questionId,
        optionId,
        numericOptions,
        weight,
        rowId,
        formId,
        kpi,
    }) {
        makeObservable(this)

        this.id = uuidv4()
        this.name = name
        this.variableType = variableType
        if (variableType !== 'kpi') {
            this.questionId = questionId
                ? questionId.toUpperCase()
                : undefined
        } else {
            this.questionId = kpi
        }

        if ((variableType === 'percentage')) {
            this.optionId = R.or(optionId, []).slice().map((id) => id.toUpperCase())
        } else if (!R.isNil(optionId)) {
            this.optionId = optionId.toUpperCase()
        } else {
            this.optionId = undefined
        }

        this.rowId = rowId
            ? rowId.toUpperCase()
            : undefined

        this.formId = formId
            ? formId.toUpperCase()
            : undefined

        if (weight) {
            this.weight = weight.kind === 'fixed'
                ? new FixedWeight(weight)
                : new QuestionWeight(weight)
        } else {
            this.weight = undefined
        }

        if (numericOptions) {
            this.numericOptions = numericOptions.map((option) => new NumericOption(option))
        }

        reaction(
            () => this.variableType,
            (variableType) => {
                if (variableType === 'optionToNumeric') {
                    this.numericOptions = [new NumericOption({
                        optionId: '00000000-0000-0000-0000-000000000000',
                        isDefault: true,
                        numericValue: 0,
                    })]
                } else if (variableType === 'percentage') {
                    this.optionId = [this.optionId].filter((id) => !R.isNil(id))
                } else if (isObservableArray(this.optionId) && ['numeric', 'answers'].includes(variableType)) {
                    this.optionId = this.optionId.slice()[0]
                } else {
                    this.numericOptions = undefined
                }
            },
        )
    }

    toJSON() {
        const optionId = (this.variableType === 'percentage')
            ? this.optionId.slice()
            : this.optionId

        const questionId = (this.variableType === 'kpi')
            ? undefined
            : this.questionId

        const kpi = (this.variableType === 'kpi')
            ? this.questionId
            : undefined

        return {
            name: this.name,
            variableType: this.variableType,
            questionId,
            kpi,
            optionId,
            rowId: this.rowId,
            weight: this.weight,
            numericOptions: this.numericOptions
                ? this.numericOptions.slice()
                : undefined,
            formId: this.formId,
        }
    }
}

export default Variable
